// The guide on the server (backend/guide.js) and who is signed in (backend/toolkit.js, through the Toolkit).
import { baseApi } from '@/shared/api';
import type { Guide } from '../model/steps';

export interface SavedGuide { rev: number; guides: Guide[] | null }
export interface Me { signedIn: boolean; superAdmin: boolean; name: string; toolkitUrl: string; canSave: boolean }

const guideApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    getGuide: b.query<SavedGuide, void>({ query: () => '/guide', providesTags: ['Guide'] }),
    getMe: b.query<Me, void>({ query: () => '/me' }),
    saveGuide: b.mutation<SavedGuide, { rev: number; guides: Guide[] }>({
      query: (body) => ({ url: '/guide', method: 'PUT', body }),
      invalidatesTags: ['Guide'],
    }),
    uploadImage: b.mutation<{ id: string }, File>({
      query: (file) => ({ url: '/guide/images', method: 'POST', body: file, headers: { 'Content-Type': file.type || 'application/octet-stream' } }),
    }),
  }),
});

export const { useGetGuideQuery, useGetMeQuery, useSaveGuideMutation, useUploadImageMutation } = guideApi;
